import { createReceiptExample } from "./shared/receiptExampleUtils";

export const receiptDetailExamplesNutripur = [
  createReceiptExample({
    amount: "1.000",
    salesPrice: "38.60",
    originalPrice: "38.60",
    itemInfo: {
      productGroupNumber: 410,
      productGroupDesc: "Food",
      subGroupNumber: 810,
      subGroupDesc: "Vital-food",
      supplierNumber: 2022,
      supplierDesc: "New",
      supplierItemText: "Nährstoffoptimiertes Your³-BUNDLE",
      refNumber:
        "nutripur-your3-naehrstoffoptimiert-sauce-teig-topping-granola-vitalstoffe-snack-besser",
      rating: 3.5,
      votings: 107,
      organic: true,
      ean: "37690100",
    },
  }),
  createReceiptExample({
    amount: "1.000",
    salesPrice: "12.90",
    originalPrice: "12.90",
    itemInfo: {
      productGroupNumber: 420,
      productGroupDesc: "Food",
      subGroupNumber: 810,
      subGroupDesc: "Vital-food",
      supplierNumber: 2022,
      supplierDesc: "Nutripur",
      supplierItemText: "Nährstoffoptimiertes Your³-Granola",
      refNumber: "Produktbild-des-knusprigen-Granolas",
      rating: 4,
      votings: 284,
      organic: false,
      ean: "4049602357187",
    },
  }),
  createReceiptExample({
    amount: "1.000",
    salesPrice: "24.90",
    originalPrice: "24.90",
    itemInfo: {
      productGroupNumber: 420,
      productGroupDesc: "Food",
      subGroupNumber: 820,
      subGroupDesc: "Protein",
      supplierNumber: 2022,
      supplierDesc: "Nutripur",
      supplierItemText: "Super Isolat Whey Protein – Neutral",
      refNumber:
        "Produktbild-des-Super-Isolat-Whey-Proteinpulvers-neutraler-Geschmack",
      rating: 5,
      votings: 231,
      organic: false,
      ean: "40412357187",
    },
  }),
  createReceiptExample({
    amount: "1.000",
    salesPrice: "1.50",
    originalPrice: "1.50",
    itemInfo: {
      productGroupNumber: 420,
      productGroupDesc: "Food",
      subGroupNumber: 830,
      subGroupDesc: "Snacks",
      supplierNumber: 2022,
      supplierDesc: "Nutripur",
      supplierItemText:
        "NUR Frucht Softies Himbeere & Apfel mit Crispies",
      refNumber: "Produktbild-NUR-Frucht-Softies-Himbeere-und-Apfel-mit-Crispies",
      rating: 5,
      votings: 7,
      organic: false,
      ean: "453976856",
    },
  }),
  createReceiptExample({
    amount: "1.000",
    salesPrice: "7.5",
    originalPrice: "7.5",
    itemInfo: {
      productGroupNumber: 420,
      productGroupDesc: "Food",
      subGroupNumber: 840,
      subGroupDesc: "Eispulver",
      supplierNumber: 2022,
      supplierDesc: "New",
      supplierItemText: "Eispulver für Protein-Eis Erdbeere",
      refNumber: "Proteineis-aus-Eispulver-und-Verpackung-des-Eispulvers",
      rating: 4,
      votings: 3,
      organic: false,
      ean: "3456897345789",
    },
  }),
  createReceiptExample({
    amount: "1.000",
    salesPrice: "13.23",
    originalPrice: "18.90",
    itemInfo: {
      productGroupNumber: 420,
      productGroupDesc: "Food",
      subGroupNumber: 850,
      subGroupDesc: "Superfood",
      supplierNumber: 2022,
      supplierDesc: "Nutripur",
      supplierItemText: "SuperPowder BIO Açai",
      refNumber: "SuperSpice-Bio-Acai",
      rating: 4.5,
      votings: 8,
      organic: true,
      ean: "23486423867",
    },
  }),
];
